import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const AnnouncementDeleteApiService = async (request: number): Promise<boolean> => {
  const url = `/announcements/${request}/`;
  const { data } = await axios.delete(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAnnouncementDeleteApiService = () =>
  useMutation<boolean, AxiosError, number>(
    AnnouncementDeleteApiService, {
      mutationKey: ["AnnouncementDeleteApiService"]
    }
  );
export default useAnnouncementDeleteApiService;